<div class="travel-guide-container" xmlns="http://www.w3.org/1999/html">
  <div class="flex-item-container force-stacked-layout" *ngIf="!isChangeTaskAtSameLocation">
    <div class="fixed-width-label">
      <div
        routeItineraryDottedLineIcon
        [iconClass]="getPrimaryLineIcon"
        [svgIconPath]="getPrimaryLineSVGIcon"
      >
        <span *ngIf="travelModes.length > 0">
          <ng-container *ngFor="let mode of travelModes; let i = index">
            {{ mode }}&nbsp;
            <span *ngIf="i < travelModes.length - 1">
              <i class="fa fa-angle-right text-xl segment-break"></i>&nbsp;
            </span>
          </ng-container>
        </span>
        <span *ngIf="travelModes.length == 0">
          {{ transportInfo.segmentType }}
        </span>
      </div>
    </div>
    <div class="flex-content-container">
      <div class="text-ds-light">
        {{ transportInfo.travelTime | minutesToHoursMinutes : 15 }}
        <ng-container *ngIf="displayCost">/ {{ costString }}</ng-container>
      </div>
      <div
        class="mt-1"
        *ngIf="transportInfo.resultCount > 1"
        (click)="showAdditionalTransportHelper = true"
      >
        <span class="additional-pt-label"
          >+{{ transportOptionsText }}<i class="las la-info-circle"></i
        ></span>
      </div>
    </div>

    <div [@slideInOut]="isDetailsOpen ? 'open' : 'closed'" class="details-section">
      <div *ngIf="isDetailsOpen">
        <div *ngFor="let segment of transportInfo.segmentParts">
          <ng-container
            [ngTemplateOutlet]="
              !segment.departureLocationName || !segment.arrivalLocationName
                ? modeOnlySegmentPart
                : standardSegmentPart
            "
            [ngTemplateOutletContext]="{ $implicit: segment }"
          ></ng-container>
        </div>
      </div>
    </div>
  </div>
  <div class="same-task-wrapper" *ngIf="isChangeTaskAtSameLocation">
    <div class="fixed-width-spacer"></div>
    <div>
      <span routeItineraryDottedLineIcon iconClass="fa fa-arrows-h">
        Change task at same location
      </span>
    </div>
  </div>
  <div class="detail-expander-options">
    <button
      pButton
      class="ui-button-secondary btn-block"
      [icon]="isDetailsOpen ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"
      (click)="toggleDetails()"
      *ngIf="this.transportInfo?.segmentParts?.length > 0"
    ></button>
  </div>
</div>

<ng-template #standardSegmentPart let-segment>
  <div class="detail-segment-row">
    <div class="segment-text">
      <span
        routeItineraryDottedLineIcon
        [iconClass]="getLineIconClass(segment.transportType)"
        [svgIconPath]="getLineSVGIconUri(segment.transportType)"
        >{{ segment.departureLocationName }}</span
      >
      <span class="separator"><i class="fa fa-angle-right"></i></span>
      <span>{{ segment.arrivalLocationName }}</span>
      <span
        *ngIf="
          (segment.transportType == RouteRecSegmentPartType.Bus ||
            segment.transportType == RouteRecSegmentPartType.Coach) &&
          segment.line?.length > 0
        "
        class="segment-line"
      >
        ({{ segment.line | titlecase }})
      </span>
      <span class="travel-time">({{ segment.travelTime | minutesToHoursMinutes : 1 }})</span>
    </div>
  </div>
</ng-template>

<ng-template #modeOnlySegmentPart let-segment>
  <div class="detail-segment-row">
    <div class="segment-text">
      <span
        routeItineraryDottedLineIcon
        [iconClass]="getLineIconClass(segment.transportType)"
        [svgIconPath]="getLineSVGIconUri(segment.transportType)"
        >{{ segment.transportType }}</span
      >
      <span class="travel-time">({{ segment.travelTime | minutesToHoursMinutes : 1 }})</span>
    </div>
  </div>
</ng-template>

<p-dialog [(visible)]="showAdditionalTransportHelper" [modal]="true" [style]="{ width: '600px' }">
  <p-header>
    <span>Public Transport Options</span>
  </p-header>
  <div>
    <p>
      We always show you what we think is the best public transport connection, but journeys don't
      always go according to plan.
    </p>
    <p>
      The <strong>'+ Transport Options'</strong> label shows the number of alternative connections
      available. Check out these other options using the Google Maps link should disruptions occur,
      or if our suggested connection doesn't suit your preferences.
    </p>
  </div>
  <p-footer>
    <button
      type="button"
      pButton
      class="ui-button-primary"
      label="Close"
      (click)="showAdditionalTransportHelper = false"
    ></button>
  </p-footer>
</p-dialog>
